import { Navigate } from 'react-router-dom';

//Dashboard
import Dashboard from 'pages/Dashboard';

//AuthenticationInner pages
import Basic404 from 'pages/AuthenticationInner/Errors/Basic404';
import Cover404 from 'pages/AuthenticationInner/Errors/Cover404';
import Alt404 from 'pages/AuthenticationInner/Errors/Alt404';
import Error500 from 'pages/AuthenticationInner/Errors/Error500';
import Offlinepage from 'pages/AuthenticationInner/Errors/Offlinepage';

import Login from 'pages/Authentication/Login';

import ProductsPage from 'pages/Products/ProductManagement';
import UserInfoPage from 'pages/user';

import ItemsPage from 'pages/Products';
import PromotionsPage from 'pages/Promotions';
import PromotionManagementPage from 'pages/Promotions/PromotionManagement';
import CategoryPage from 'pages/Category';
import OldLogin from 'pages/Authentication/OldLogin';
import ProductOptionsPage from 'pages/ProductOptions';
import ProductOptionManagementPage from 'pages/ProductOptions/ProductOptionManagement';
import NoAccess from 'pages/NoAccess';
import {
  CATEGORY,
  CUSTOMER,
  ITEMS,
  PRODUCT_OPTION,
  PROMOTIONS,
  SETTINGS,
  TAG,
  TIME_ATTENDANCE,
} from 'Routes/constants';
import TagsPage from 'pages/Tags';
import CustomersPage from 'pages/Customers';
import TimeAttendancePage from 'pages/TimeAttendance';
import SettingsPageV2 from 'pages/SettingsV2';

const publicRoutes = (authStatus: boolean) => [
  {
    path: '/login',
    component: authStatus ? (
      <Navigate to="/" />
    ) : process.env.NODE_ENV === 'development' ? (
      <Login />
    ) : (
      <OldLogin />
    ),
  },
  { path: '/auth-404-basic', component: <Basic404 /> },
  { path: '/auth-404-cover', component: <Cover404 /> },
  { path: '/auth-404-alt', component: <Alt404 /> },
  { path: '/auth-500', component: <Error500 /> },
  { path: '/auth-offline', component: <Offlinepage /> },
];

const authProtectedRoutes = [
  { path: '/no-access/*', component: <NoAccess /> },
  { path: '/home', component: <Dashboard /> },
  { path: '/index', component: <Dashboard /> },

  //todo ======================== POS2U ======================== //
  { path: ITEMS.LIST, component: <ItemsPage /> },
  // { path: '/products', component: <ProductsPage /> },
  // { path: '/products/:id', component: <ProductsPage /> },
  { path: ITEMS.ADD, component: <ProductsPage /> },
  { path: ITEMS.ID, component: <ProductsPage /> },
  { path: PRODUCT_OPTION.LIST, component: <ProductOptionsPage /> },
  { path: PRODUCT_OPTION.ADD, component: <ProductOptionManagementPage /> },
  { path: PRODUCT_OPTION.ID, component: <ProductOptionManagementPage /> },

  { path: PROMOTIONS.LIST, component: <PromotionsPage /> },
  { path: PROMOTIONS.ADD, component: <PromotionManagementPage /> },
  { path: PROMOTIONS.ID, component: <PromotionManagementPage /> },

  { path: CATEGORY.LIST, component: <CategoryPage /> },
  { path: TAG.LIST, component: <TagsPage /> },

  { path: CUSTOMER.LIST, component: <CustomersPage /> },
  { path: TIME_ATTENDANCE.LIST, component: <TimeAttendancePage /> },
  { path: SETTINGS.ROOT, component: <SettingsPageV2 /> },
  // { path: SETTINGS.V2, component: <SettingsPageV2 /> },

  //   { path: ITEMS.LIST, component: <ItemsPage /> },

  // { path: ITEMS.ADD, component: <ProductsPage /> },
  // { path: ITEMS.ID, component: <ProductsPage /> },
  // { path: PRODUCT_OPTION.LIST, component: <ProductOptionsPage /> },
  // { path: PRODUCT_OPTION.ADD, component: <ProductOptionManagementPage /> },
  // { path: PRODUCT_OPTION.ID, component: <ProductOptionManagementPage /> },

  // { path: PROMOTIONS.LIST, component: <PromotionsPage /> },
  // { path: PROMOTIONS.ADD, component: <PromotionManagementPage /> },
  // { path: PROMOTIONS.ID, component: <PromotionManagementPage /> },

  // { path: CATEGORY, component: <CategoryPage /> },

  { path: '/user-info', component: <UserInfoPage /> },
  //todo ======================== POS2U ======================== //

  //User Profile
  // { path: '/profile', component: <UserProfile /> },

  // this route should be at the end of all other routes
  {
    path: '/',
    exact: true,
    component: <Navigate to="/home" />,
  },
  { path: '*', component: <Navigate to="/home" /> },
];

export { authProtectedRoutes, publicRoutes };
